import React ,{useEffect,useState,useRef} from 'react';
import { Footer, Navbar } from "../components";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME,Image_Base_Url,ACCESS_Role_ID,ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import '../assets/css/bootstrap.min.css';
import '../assets/css/fontawesome-all.min.css';
import '../assets/css/slick.css';
import '../assets/css/line-awesome.min.css';
import '../assets/css/main.css';
import '../assets/css/responsive.css';
import '../assets/stylesheet/style.css'
import SearchImage from '../../src/assets/images/all/search.svg'
import LogoImage from '../../src/assets/images/all/scan-svgrepo-com 1.svg'
import ProfileImage from '../../src/assets/images/all/profiel.png'
import GroupImage from '../../src/assets/images/icons/Group 85.svg'
import ArticleImage from '../../src/assets/images/icons/design-distribution-of-elements-of-an-article-svgrepo-com 1.svg'
import FeddImage from '../../src/assets/img/feed/thumbpng.png'
import FeedImage from '../../src/assets/img/feed/01.jpg'
import FeedImage1 from '../../src/assets/img/feed/02.jpg'
import FeedImage2 from '../../src/assets/img/feed/03.jpg'
import shapeImage from "../../src/assets/images/all/shape_1.png"
import shapeImage1 from "../../src/assets/images/icons/Unions.svg"

const Feed = () => {
  const [feed, setFeed] = useState([]); // State to hold roles data
  const [loading, setLoading] = useState(true); // State to track loading status
  const [error, setError] = useState(null); // State to hold error messages
  const navigate = useNavigate();
  console.log("ACCESS_Log_In_User_Id"+ACCESS_Log_In_User_Id());
  //const ACCESS_TOKEN_NAME = localStorage.getItem('ACCESS_TOKEN_NAME');
  // useEffect(() => {
  //   const url = API_BASE_URL + '/feeds'
  //   const fetchRoles = async () => {
  //       try {
  
  //           const response = await axios.get(url);
  //           console.log(response.data);
  //           setFeed(response.data); // Set roles data to state
  //           setLoading(false); // Set loading to false
  //       } catch (err) {
  //           setError(err.message); // Handle error
  //           setLoading(false); // Set loading to false
  //       }
  //   };
  
  //   fetchRoles(); // Call the fetch function
  // }, []); // Empty dependency array to run only on mount

  useEffect(() => {
    const url = API_BASE_URL + '/feeds';
  
    const fetchRoles = async () => {
      try {
        const response = await axios.get(url, {
          headers: {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, // Replace with your actual token
            "Content-Type": "application/json",
          },
        });
        console.log(response.data);
        setFeed(response.data); // Set roles data to state
        setLoading(false);
      } catch (err) {
        console.error("Error fetching feeds:", err); // Log error
        setError(err.message); // Handle error
        setLoading(false);
      } finally {
        setLoading(false); // Set loading to false
      }
    };
  
    fetchRoles(); // Call the fetch function
  }, []); // Empty dependency array to run only on mount
  

  const fileInputRef = useRef(null);

    const handleMediaClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const files = event.target.files;
        console.log('Selected files:', files);
     
    };
const showModal = () =>{
  const bootstrap = require('bootstrap');
  const myModal = new bootstrap.Modal(document.getElementById('postModal'), {
      backdrop: 'static',
      keyboard: false
  });
  myModal.show();
}

  
  return (
    <div>
      {/* Scroll to Top */}
      <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>

      {/* Mobile Menu */}
      <div className="mobile-menu d-lg-none d-block">
        <button type="button" className="close-button">
          <i className="las la-times"></i>
        </button>
        <div className="mobile-menu__inner">
          <ul className="nav-menu flx-align nav-menu--mobile">
            <li className="nav-menu__item activePage">
              <a href="/" className="nav-menu__link">Home</a>
            </li>
            {/* Add other menu items here */}
          </ul>
          <div className="header-right__inner d-lg-none my-3 gap-1 d-flex flx-align">
            <a href="/" className="btn btn-main pill sign_btn px-sm-4">
              Signup/Login
            </a>
          </div>
        </div>
      </div>

      {/* <img className="shape_top d-lg-block d-none" src={shapeImage} alt="" />
      <img className="shape_top_6 d-xl-block d-none" src={shapeImage1} alt="" /> */}


          <Navbar/>

          <main class="">
        
    
        <section class="py-4 hero-section">
            <div class="container">
                <div class="row">
        <div class="text-center form-group srch_area mt-3 layer_up"><input type="search" name="search-field" placeholder="Find Institute, Colleges, Courses, Exams" value=""/><i class="far fa-search srch_glass"></i><button type="submit">Search</button><ul><p></p><p></p><p></p></ul></div>
                    </div>
                </div>
         </section>
    


<section class="py-4 feed_comment">
            <div class="container">
                <div class="row">
        <div class="spl_cards">
                    
                   <div class="coment_all_wrap">
            
                       <div class="feed_img me-3"><img src={FeddImage} /></div>
            <div class="w-100"><textarea name="message" cols="30" rows="2" class="form-control" placeholder="Write what's in your mind?"></textarea></div>
            </div>
                    </div>
  
                    </div>
                
                <div class="row pt-4">
                    {feed.map((item, i) => (
                                        <div class="col-md-6 col-lg-4">
                                        <div class="blog-item">
                                            <div class="blog-item-img">
                                                <img src={`${Image_Base_Url}${item.post_image_path}`} alt="" />
                                            </div>
                                            <div class="blog-item-info">
                                                <div class="blog-item-meta">
                                                    <ul>
                                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                                    </ul>
                                                </div>
                                               <p>{item.post_title}</p>
                                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                                            </div>
                                        </div> 
                                    </div>
                                      ))}
                    
                    
                    
                    
                    
                   {/* <div class="col-md-6 col-lg-4">
                        <div class="blog-item">
                            <div class="blog-item-img">
                                <img src={FeedImage1} alt="Thumb"/>
                            </div>
                            <div class="blog-item-info">
                                <div class="blog-item-meta">
                                    <ul>
                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                    </ul>
                                </div>
                               <p>There are many variations passage have suffered available.</p>
                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                            </div>
                        </div> 
                    </div>
                    
                     <div class="col-md-6 col-lg-4">
                        <div class="blog-item">
                            <div class="blog-item-img">
                                <img src={FeedImage2} alt="Thumb"/>
                            </div>
                            <div class="blog-item-info">
                                <div class="blog-item-meta">
                                    <ul>
                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                    </ul>
                                </div>
                               <p>There are many variations passage have suffered available.</p>
                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                            </div>
                        </div> 
                    </div>
                    
                    <div class="col-md-6 col-lg-4">
                        <div class="blog-item">
                            <div class="blog-item-img">
                                <img src={FeedImage} alt="Thumb"/>
                            </div>
                            <div class="blog-item-info">
                                <div class="blog-item-meta">
                                    <ul>
                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                    </ul>
                                </div>
                               <p>There are many variations passage have suffered available.</p>
                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                            </div>
                        </div> 
                    </div>
                    
                    <div class="col-md-6 col-lg-4">
                        <div class="blog-item">
                            <div class="blog-item-img">
                                <img src={FeedImage2} alt="Thumb"/>
                            </div>
                            <div class="blog-item-info">
                                <div class="blog-item-meta">
                                    <ul>
                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                    </ul>
                                </div>
                               <p>There are many variations passage have suffered available.</p>
                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                            </div>
                        </div> 
                    </div>
                    
                    <div class="col-md-6 col-lg-4">
                        <div class="blog-item">
                            <div class="blog-item-img">
                                <img src={FeedImage2} alt="Thumb"/>
                            </div>
                            <div class="blog-item-info">
                                <div class="blog-item-meta">
                                    <ul>
                                        <li><a href="#"><i class="far fa-user-circle"></i></a></li>
                                        <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                         <li><a href="#"><i class="far fa-comments"></i> </a></li>
                                    </ul>
                                </div>
                               <p>There are many variations passage have suffered available.</p>
                               <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Add a Comment...."></textarea>
                            </div>
                        </div> 
                    </div> */}
                </div>
                
                </div>
         </section>
        

    </main>

    <button class="btn btn-primary enquire_now" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now</button>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header">
    <h4 id="offcanvasRightLabel">Enquire <span class="orange">Now</span></h4>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
   <div class="row contact-form py-0">
       <div class="col-md-12">
           <div class="form-group">
               <input type="text" class="form-control" name="name" placeholder="Your Name" required=""/>
           </div>
       </div>
       <div class="col-md-12">
           <div class="form-group">
               <input type="email" class="form-control" name="email" placeholder="Your Email" required=""/>
           </div>
       </div>
       <div class="col-md-12">
           <div class="form-group">
               <input type="phone" class="form-control" name="phone" placeholder="Your Contact Number" required=""/>
           </div>
           <div class="col-md-12">
               <div class="form-group">
                   <select class="form-select form-control" aria-label="city">
                       <option selected>City</option>
                       <option value="1">One</option>
                       <option value="2">Two</option>
                       <option value="3">Three</option>
                   </select>
               </div>
           </div>
           <div class="col-md-12">
               <div class="form-group">
                   <select class="form-select form-control" aria-label="courses">
                       <option selected>Courses</option>
                       <option value="1">MBA</option>
                       <option value="2">BBA</option>
                       <option value="3">Btech</option>
                   </select>
               </div>
           </div>
           <div class="col-md-12">
               <div class="form-group">
                   <select class="form-select form-control" aria-label="courses">
                       <option selected>College for Admission</option>
                       <option value="1">MBA</option>
                       <option value="2">BBA</option>
                       <option value="3">Btech</option>
                   </select>
               </div>
           </div>
           <div class="col-md-12">
               <div class="form-group">
                   <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Write Your Message"></textarea>
               </div>
           </div>
           <button type="submit" class="theme-btn">Submit
               <i class="far fa-paper-plane"></i></button>
       </div>
   </div>
  </div>
</div>
    

  

       
        <Footer/>
 
    
    </div>
  );
};

export default Feed;
